import { createRouter, createWebHistory } from 'vue-router'
import index from '../views/index/index.vue'
 
const router = createRouter({
  history: createWebHistory(),
  scrollBehavior(){
      return{
        left:0,
        top:0
      }
  },
  routes: [
  {
    path: '/',
    name: 'index',
    component: index,
    meta: {
      title: '超拼网—严选源头好货！',
      keywords: '下载中心'
    }
  },
  {
    path: '/download',
    name: 'download',
    component: () => import('@/views/download/index.vue'), // 懒加载
    meta: {
      title: '下载中心',
      keywords: '超级能拼、一网打尽 扫码下载超拼网APP',
      description:'超级能拼、一网打尽 扫码下载超拼网APP,扫码超拼网小程序'
    }
  },
  {
    path: '/cooperation',
    name: 'cooperation',
    component: () => import('@/views/cooperation/index.vue'), // 懒加载
    meta: {
      title: '合作入驻',
      keywords: '商家入驻流程-资质要求-代运营服务商入驻',
      description: '下载超拼网APP，选择开店，准备 好所需的资料。填入后提交申请。平台进行评估、资质审核 （约1-5个工作日），平台审核通过后，通过对公账户 缴纳保证金（约1-3个工作日），开店成功，开始运营你的店铺吧'
    }
  },
  {
    path: '/problem',
    name: 'problem',
    component: () => import('@/views/cooperation/problem.vue'), // 懒加载
    meta: {
      title: '常见问题',
      keywords: '店铺类型,主营类目,资质相关,保证金相关,售后问题,代运营相关,其他',
    }
  },
  {
    path: '/news',
    name: 'news',
    component: () => import('@/views/news/index.vue'), // 懒加载
    meta: {
      title: '热点新闻',
      keywords: '超拼网-热点新闻-新闻中心',
      description: '热点新闻吗，超拼新闻，行业新闻，超拼网携手AI大健康研讨会，共赴健康新征程，超拼网合规经营白皮书，超拼网亮相大健康领域普法培训会 深度解析药品销售合规经营之道，携手推进普法教育，超拼网与多方合作助力健康行业法治发展，超拼联盟第一届大会在贵阳圆满落幕，共筑合作新篇'
    }
  },{
    path: '/details',
    name: 'details',
    component: () => import('@/views/news/details.vue') // 懒加载
  },{
    path: '/user',
    name: 'user',
    component: () => import('@/views/user/index.vue'), // 懒加载
    meta: {
      title: '关于我们',
      keywords: '超拼网简介,企业文化,领导团队,发展大事记,获得荣誉',
      description: '超拼网通过技术创新和自主研发，采用驱动创新的“M2C”无中间商的运营模式，坚持原产地直发，源头追溯，以“为消费者提供绿色健康的农产品”为宗旨，整合产业链、供应链、物流、仓储、大数据、人工智能等各方面资源，以移动互联网为介质，将农民、制造商和消费者直接连接起来，剔除中间环节，无中间商，降低产品成本，搭建从产地到消费者之间的直供平台。'
    }
  },{
    path: '/wanted',
    name: 'wanted',
    component: () => import('@/views/wanted/index.vue'), // 懒加载
    meta: {
      title: '人才招聘',
      keywords: '执业药师,商务助理,客服专员,平面设计,电商运营',
    }
  },{
    path: '/wanteddetails',
    name: 'wanteddetails',
    component: () => import('@/views/wanted/details.vue'), // 懒加载
    meta: {
      title: '人才招聘',
    }
  },{
    path: '/wantedlist',
    name: 'wantedlist',
    component: () => import('@/views/wanted/list.vue') // 懒加载
  }
//   {
//     path: '/user',
//     name: 'user',
//     component: () => import('@/components/User.vue') // 懒加载
//   }
   
  ]
})
 
export default router